import {
    RaikoBaseDialogContentContainer,
    RaikoGridOneColumn, RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {GameStageService} from "../../../serverService/gameService/GameStageService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";

export default function AddNewGameStage({gameId, handleCloseDialog, handleAddNewGameStageToTable}) {

    const [actionButtonLoading, setActionButtonLoading] = useState(false)
    const [gameStageTitle, setGameStageTitle] = useState("");
    const [scoreWeight, setScoreWeight] = useState(0);
    const [maxScore, setMaxScore] = useState(0);

    const service = new GameStageService()


    function handleCreateNewGameStage() {
        setActionButtonLoading(true)
        service.addNewGameStage(gameId, gameStageTitle, scoreWeight, maxScore)
            .then(response => {
                handleCloseDialog()
                handleAddNewGameStageToTable(response)
                showSuccessMessage("مرحله جدید با موفقیت افزوده شد.")
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن مرحله"}
                hasActionButton
                actionButtonTitle={"افزودن"}
                actionButtonLoadingState={actionButtonLoading}
                actionButtonOnclickWithValidation={handleCreateNewGameStage}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseDialog}
            >
                <RaikoGridOneColumn>
                    <RaikoSimpleInputOutlined
                        labelText={"عنوان مرحله"}
                        value={gameStageTitle}
                        setValue={setGameStageTitle}
                        required
                    />
                    <RaikoNumberInputOutlined
                        labelText={"وزن امتیاز"}
                        value={scoreWeight}
                        setValue={setScoreWeight}
                        required
                    />
                    <RaikoNumberInputOutlined
                        labelText={"حداکثر امتیاز"}
                        value={maxScore}
                        setValue={setMaxScore}
                        required
                    />
                </RaikoGridOneColumn>

            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>

    )
}